export const mapNullableBooleanToBoolean = (
  booleanValue: boolean | null | undefined,
): boolean | undefined => {
  return booleanValue ?? undefined;
};
